import request from '@/utils/request'

export function findBaseProfileProducts(params) {
  return request({
    url: `/base_profile_products`,
    method: 'get',
    params
  })
}

export function findImportableBaseProfileProducts(params) {
  return request({
    url: `/base_profile_products/importable`,
    method: 'get',
    params
  })
}

export function createBaseProfileProduct(data) {
  return request({
    url: `/base_profile_products`,
    method: 'post',
    data
  })
}

export function findBaseProfileProductForm(id) {
  return request({
    url: `/base_profile_products/${id}/form`,
    method: 'get'
  })
}

export function updateBaseProfileProduct(id, data) {
  return request({
    url: `/base_profile_products/${id}`,
    method: 'put',
    data
  })
}

export function batchUpdateBaseProfileProductsEffective(ids, effective) {
  return request({
    url: `/base_profile_products/effective/batch`,
    method: 'patch',
    data: { ids, effective }
  })
}
